import { playNotificationSound, unlockNotificationSound } from "packs/admin-notification-sounds"
import { setCollapsed } from "packs/init-backoffice-nav-collapse"

const csrfToken = () => document.querySelector("meta[name='csrf-token']")?.content

const persist = async (url, payload) => {
  if (!url) return

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken() || ""
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok) return null

  return response.json()
}

const bindSoundSettings = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const enabledField = root.querySelector("[data-settings-sound-enabled]")
  const changeSoundRoot = root.querySelector("[data-settings-change-sound]")
  const registrationSoundRoot = root.querySelector("[data-settings-registration-sound]")
  const changeSoundField = changeSoundRoot?.querySelector("[data-backoffice-select-field]")
  const registrationSoundField = registrationSoundRoot?.querySelector("[data-backoffice-select-field]")
  const toggle = enabledField?.closest(".backoffice-toggle")

  const setSoundSelectEnabled = (enabled) => {
    root.querySelectorAll("[data-backoffice-select-trigger]").forEach((trigger) => {
      trigger.disabled = !enabled
    })
    root.querySelectorAll(".backoffice-settings__sound").forEach((block) => {
      block.classList.toggle("is-disabled", !enabled)
    })
  }

  setSoundSelectEnabled(enabledField?.checked !== false)

  enabledField?.addEventListener("change", () => {
    const enabled = enabledField.checked
    toggle?.classList.toggle("is-on", enabled)
    setSoundSelectEnabled(enabled)
    persist(root.dataset.settingsUrl, { enabled }).then((data) => {
      if (!data) return
      if (typeof data.enabled === "boolean") {
        document.body.dataset.notificationSoundEnabled = data.enabled ? "1" : "0"
      }
    })
    if (enabled) {
      unlockNotificationSound()
      playNotificationSound(changeSoundField?.value)
    }
  })

  changeSoundField?.addEventListener("change", () => {
    persist(root.dataset.settingsUrl, { sound: changeSoundField.value }).then((data) => {
      if (data?.sound) document.body.dataset.notificationSound = data.sound
    })
    if (enabledField?.checked) {
      unlockNotificationSound()
      playNotificationSound(changeSoundField.value)
    }
  })

  registrationSoundField?.addEventListener("change", () => {
    persist(root.dataset.settingsUrl, { registration_sound: registrationSoundField.value }).then((data) => {
      if (data?.registration_sound) document.body.dataset.registrationSound = data.registration_sound
    })
    if (enabledField?.checked) {
      unlockNotificationSound()
      playNotificationSound(registrationSoundField.value)
    }
  })
}

const bindInterfaceSettings = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const homePageField = root.querySelector("[data-settings-home-page] [data-backoffice-select-field]")
  const navField = root.querySelector("[data-settings-nav-collapsed]")
  const navToggle = navField?.closest(".backoffice-toggle")

  homePageField?.addEventListener("change", () => {
    persist(root.dataset.homePageUrl, { home_page: homePageField.value })
  })

  navField?.addEventListener("change", () => {
    const collapsed = navField.checked
    navToggle?.classList.toggle("is-on", collapsed)
    setCollapsed(collapsed)
  })
}

export const initBackofficeSettings = () => {
  document.querySelectorAll("[data-backoffice-settings]").forEach(bindSoundSettings)
  document.querySelectorAll("[data-backoffice-interface-settings]").forEach(bindInterfaceSettings)
}
